import type SignDrawables from "@/signomatic/app/sign_drawables"
import WithImages from "../with_images"
import type { DrawableMixin } from "../objects/drawable_mixin"

export interface FixmethodPosition {
  left?: number
  top?: number
  diameter?: number
  headDiameter?: number
  imageDiamater?: number
  stretch?: boolean
  flathead?: boolean
}

export default abstract class Fixmethod extends WithImages {
  protected readonly drawables: SignDrawables

  constructor(drawables: SignDrawables) {
    super()
    this.drawables = drawables
    this.loadImages()
  }

  get externalTop(): boolean {
    return false
  }

  get externalBottom(): boolean {
    return false
  }

  get externalSides(): boolean {
    return false
  }

  get externalGap(): number {
    return 0
  }

  get externalTopPadding(): number {
    return 0
  }

  get externalBottomPadding(): number {
    return 0
  }

  get externalLeftPadding(): number {
    return 0
  }

  get externalRightPadding(): number {
    return 0
  }

  /** Padding to ensure external visuals are not clipped. */
  get visualPadding() {
    return { top: 0, bottom: 0, left: 0, right: 0 }
  }

  get count(): number {
    return 0
  }

  protected get state() {
    return this.drawables.state
  }

  protected get thornDistance() {
    if (this.state.shape !== "thorny") {
      return 0
    }

    const borderExtra = this.drawables.hasBorder ? 1.5 : 1
    const points = this.drawables.star("thorny", this.state.widthPx, this.state.heightPx)
    return (points[50].x - points[51].x) * borderExtra
  }

  protected get isStainless() {
    return (
      this.drawables.signType === "stainless_steel_sign" ||
      (this.drawables.signType === "label_plates" && this.state.material === "stainless")
    )
  }

  bottomDrawable(): DrawableMixin | null {
    return null
  }

  baseDrawable(): DrawableMixin | null {
    return null
  }

  topDrawable(): DrawableMixin[] | null {
    return null
  }

  engravingDrawable(): DrawableMixin[] | null {
    return null
  }

  autoSizePadding(_state: SignState) {
    return 0
  }

  protected redraw() {
    this.drawables.redraw()
  }
}
